(function (window, document) {
    'use strict';

    function initialise(dialog) {
        if (dialog.getAttribute('data-care-home-enquiry-ready') === 'true') return;
        var hub = dialog.closest('.care-at-home');
        if (!hub) return;

        dialog.setAttribute('data-care-home-enquiry-ready', 'true');
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
        var formHost = dialog.querySelector('.custom-form-widget__form');
        var details = dialog.querySelector('[data-care-home-enquiry-details]');
        var summary = dialog.querySelector('[data-care-home-enquiry-summary]');
        var title = dialog.querySelector('#care-at-home-enquiry-title');
        var opener = null;
        var fallback = false;

        function isOpen() {
            return dialog.hasAttribute('open');
        }

        function syncHospital() {
            var applied = hub.querySelector('[data-care-home-hospital-content]');
            var id = applied && applied.getAttribute('data-hospital-selected') === 'true'
                ? applied.getAttribute('data-hospital-id') || '' : '';
            if (!/^[1-9]\d*$/.test(id)) id = '';
            var fields = dialog.querySelectorAll('[data-care-home-enquiry-hospital]');
            for (var i = 0; i < fields.length; i += 1) {
                if (fields[i].value !== id) fields[i].value = id;
            }

            var label = '';
            var select = hub.querySelector('[data-care-home-location] select[name="hospital"]');
            if (id && select) {
                for (var index = 0; index < select.options.length; index += 1) {
                    if (select.options[index].value === id) {
                        label = select.options[index].textContent.trim();
                        break;
                    }
                }
            }
            if (summary) {
                var text = label ? 'Hospital: ' + label : '';
                if (summary.textContent !== text) summary.textContent = text;
                if (summary.hidden !== !label) summary.hidden = !label;
            }
        }

        function directChild(parent, attribute) {
            for (var i = 0; i < parent.children.length; i += 1) {
                if (parent.children[i].hasAttribute(attribute)) return parent.children[i];
            }
            return null;
        }

        function ensureFooter(parent) {
            var footer = directChild(parent, 'data-care-home-enquiry-footer');
            if (!footer) {
                footer = document.createElement('footer');
                footer.className = 'care-at-home-enquiry__footer';
                footer.setAttribute('data-care-home-enquiry-footer', '');
                parent.appendChild(footer);
            }
            var dismiss = footer.querySelector('[data-care-home-enquiry-close]');
            if (!dismiss) {
                dismiss = document.createElement('button');
                dismiss.type = 'button';
                dismiss.className = 'care-at-home-enquiry__dismiss';
                dismiss.setAttribute('data-care-home-enquiry-close', '');
                dismiss.textContent = 'Close';
                footer.insertBefore(dismiss, footer.firstChild);
            }
            return footer;
        }

        function prepareLayout() {
            if (!formHost) return;
            var form = formHost.querySelector('form');
            var body = directChild(formHost, 'data-care-home-enquiry-body');
            var footer = directChild(formHost, 'data-care-home-enquiry-footer');

            if (form) {
                if (body) {
                    while (body.firstChild) formHost.insertBefore(body.firstChild, body);
                    formHost.removeChild(body);
                }
                if (footer) formHost.removeChild(footer);
                if (details && (details.parentNode !== form || form.firstChild !== details)) {
                    form.insertBefore(details, form.firstChild);
                }
                var submit = form.querySelector('input[type="submit"], button[type="submit"]');
                footer = ensureFooter(form);
                if (submit && submit.parentNode !== footer) footer.appendChild(submit);
            } else {
                if (!body) {
                    body = document.createElement('div');
                    body.className = 'care-at-home-enquiry__body';
                    body.setAttribute('data-care-home-enquiry-body', '');
                    formHost.insertBefore(body, formHost.firstChild);
                }
                if (details && (details.parentNode !== body || body.firstChild !== details)) {
                    body.insertBefore(details, body.firstChild);
                }
                var output = Array.prototype.slice.call(formHost.childNodes);
                for (var i = 0; i < output.length; i += 1) {
                    if (output[i] !== body && output[i] !== footer) body.appendChild(output[i]);
                }
                ensureFooter(formHost);
            }
        }

        function prepareFields() {
            if (!formHost) return;
            prepareLayout();
            var fields = formHost.querySelectorAll('.form-field');
            for (var i = 0; i < fields.length; i += 1) {
                var field = fields[i];
                var controls = field.querySelectorAll('input, select, textarea, button');
                var hiddenOnly = controls.length > 0;
                for (var index = 0; index < controls.length; index += 1) {
                    if (controls[index].type !== 'hidden') hiddenOnly = false;
                }
                field.classList.toggle('care-at-home-enquiry__field--hidden', hiddenOnly);
                field.classList.toggle('care-at-home-enquiry__field--wide',
                    !!field.querySelector('.ktc-radio-list, textarea:not([name="g-recaptcha-response"])'));
            }
            syncHospital();
        }

        function focusableElements() {
            var candidates = dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]');
            var result = [];
            for (var i = 0; i < candidates.length; i += 1) {
                var element = candidates[i];
                if (!element.disabled && element.type !== 'hidden' && element.tabIndex >= 0
                    && !element.closest('[hidden], [inert]') && element.getClientRects().length) {
                    result.push(element);
                }
            }
            return result;
        }

        function focusFormResult() {
            if (!isOpen() || dialog.contains(document.activeElement)) return;
            var errors = formHost.querySelectorAll('input.input-validation-error, select.input-validation-error, textarea.input-validation-error');
            var destination = null;
            for (var i = 0; i < errors.length; i += 1) {
                if (!errors[i].disabled && errors[i].type !== 'hidden'
                    && !errors[i].closest('[hidden], [inert]') && errors[i].getClientRects().length) {
                    destination = errors[i];
                    break;
                }
            }
            if (!destination) {
                var success = formHost.querySelector('.formwidget-submit-text');
                if (success && !success.closest('[hidden], [inert]') && success.getClientRects().length) {
                    success.setAttribute('tabindex', '-1');
                    destination = success;
                }
            }
            destination = destination || title;
            if (destination) {
                try { destination.focus({ preventScroll: true }); } catch (error) { destination.focus(); }
            }
        }

        function restoreFocus() {
            document.body.classList.remove('care-at-home-enquiry-open');
            if (opener && document.documentElement.contains(opener) && typeof opener.focus === 'function') {
                try { opener.focus({ preventScroll: true }); } catch (error) { opener.focus(); }
            }
            opener = null;
        }

        function close() {
            if (!isOpen()) return;
            if (!fallback && typeof dialog.close === 'function') {
                dialog.close();
            } else {
                dialog.removeAttribute('open');
                restoreFocus();
            }
            dialog.classList.remove('care-at-home-enquiry--fallback');
            fallback = false;
        }

        function open(link) {
            prepareFields();
            if (isOpen()) return;
            opener = link || document.activeElement;
            if (typeof dialog.showModal === 'function') {
                try { dialog.showModal(); } catch (error) { fallback = true; }
            } else {
                fallback = true;
            }
            if (fallback) {
                dialog.setAttribute('open', '');
                dialog.classList.add('care-at-home-enquiry--fallback');
            }
            document.body.classList.add('care-at-home-enquiry-open');
            var initialFocus = title || dialog.querySelector('[data-care-home-enquiry-close]');
            if (initialFocus) {
                try { initialFocus.focus({ preventScroll: true }); } catch (error) { initialFocus.focus(); }
            }
        }

        function outsidePanel(event) {
            var bounds = dialog.getBoundingClientRect();
            return event.clientX < bounds.left || event.clientX > bounds.right
                || event.clientY < bounds.top || event.clientY > bounds.bottom;
        }

        document.addEventListener('click', function (event) {
            var target = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
            var link = target && target.closest('a[href]');
            if (link && link.closest('.care-at-home') === hub && !event.defaultPrevented
                && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey
                && (event.button === undefined || event.button === 0) && !link.hasAttribute('download')) {
                try {
                    var url = new window.URL(link.getAttribute('href'), window.location.href);
                    if (url.origin === window.location.origin && url.hash === '#form') {
                        event.preventDefault();
                        open(link);
                        return;
                    }
                } catch (error) { /* Leave unrelated or malformed links to the browser. */ }
            }
            if (fallback && isOpen() && target && !dialog.contains(target) && outsidePanel(event)) {
                event.preventDefault();
                close();
            }
        });

        dialog.addEventListener('click', function (event) {
            var target = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
            if (target && target.closest('[data-care-home-enquiry-close]')) {
                event.preventDefault();
                close();
            } else if (event.target === dialog && outsidePanel(event)) {
                close();
            }
        });

        dialog.addEventListener('cancel', function (event) {
            event.preventDefault();
            close();
        });
        dialog.addEventListener('close', function () {
            if (!isOpen()) restoreFocus();
        });
        dialog.addEventListener('submit', syncHospital, true);
        document.addEventListener('care-at-home:hospital-change', syncHospital);

        document.addEventListener('keydown', function (event) {
            if (!isOpen()) return;
            if (event.key === 'Escape') {
                event.preventDefault();
                close();
                return;
            }
            if (event.key !== 'Tab') return;
            var elements = focusableElements();
            if (!elements.length) {
                event.preventDefault();
                if (title) title.focus();
                return;
            }
            var first = elements[0];
            var last = elements[elements.length - 1];
            var current = document.activeElement;
            if (event.shiftKey && (current === first || elements.indexOf(current) === -1)) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && (current === last || elements.indexOf(current) === -1)) {
                event.preventDefault();
                first.focus();
            }
        });

        if (formHost && window.MutationObserver) {
            new window.MutationObserver(function () {
                prepareFields();
                focusFormResult();
            }).observe(formHost, { childList: true, subtree: true });
        }
        window.addEventListener('hashchange', function () {
            if (window.location.hash === '#form') open(null);
        });
        prepareFields();
        if (window.location.hash === '#form') open(null);
    }

    function start() {
        var dialogs = document.querySelectorAll('[data-care-home-enquiry]');
        for (var i = 0; i < dialogs.length; i += 1) initialise(dialogs[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
}(window, document));
